import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../AppProvider";
import "../../../../styles/Widgets/Charts/EditBarChartWidget.css";
import { DashboardContext } from "../../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
import ToogleButton from "../../../controls/ToogleButton";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import "react-datepicker/dist/react-datepicker.css";
import TimeWindowSelector, { getQuickIntervalByValue, getTimeIntervalByValue } from "../../../controls/TimeWindowSelector";
import { defaultTimeWindow } from "../../../controls/libraries/defaultTimeWindow";

const EditBarChartWidget = () =>{
    const {user} = useContext(AppContext);
    const {
        activeEditWidget,setActiveEditWidget
    } = useContext(DashboardContext);
    const {tenantId} = useParams();
    const [timeWindowSource,setTimeWindowSource] = useState('WIDGET');
    const [displayTimeWindow,setDisplayTimeWindow] = useState(true);
    const [showTimeWindowSelector,setShowTimeWindowSelector] = useState(false);
    const [timeWindow,setTimeWindow] = useState({...defaultTimeWindow});

    const [selectedDataSourceType,setSelectedDataSourceType] = useState('device');
    const [showDevicesBrowser,setShowDevicesBrowser] = useState(false);
    const [showEntityAliasBrowser,setShowEntityAliasBrowser] = useState(false);
    const [devicesSummary,setDevicesSummary] = useState([]);
    const [dataSourceDeviceFilterString,setDataSourceDeviceFilterString] = useState('');
    const [dataSourceEntityAliasFilterString,setDataSourceEntityAliasFilterString] = useState('');
    const [selectedDataSourceDeviceId,setSelectedDataSourceDeviceId] = useState('');
    const [selectedDataSourceDeviceSummary,setSelectedDataSourceDeviceSummary] = useState(null);
    const [selectedDataSourceDevice,setSelectedDataSourceDevice] = useState(null);
    const [series,setSeries] = useState([]);
    const [title,setTitle] = useState('');
    const [showTitle,setShowTitle] = useState(true);
    const [titleColor,setTitleColor] = useState('#000000');
    const [borderRadius,setBorderRadius] = useState(0);
    const [mobileHeightFactor,setMobileHeightFactor] = useState(5);
    const [maximumValue,setMaximumValue] = useState('');
    const [changesAvailable,setChangesAvailable] = useState(true);
    const timeWindowSelectorContainerRef = useRef(null);
    const units = [
        { name: 'Nanometer', symbol: 'nm' },
        { name: 'Micrometer', symbol: 'µm' },
        { name: 'Millimeter', symbol: 'mm' },
        { name: 'Centimeter', symbol: 'cm' },
        { name: 'Meter', symbol: 'm' },
        { name: 'Kilometer', symbol: 'km' },

        { name: 'Cubic millimeter', symbol: 'mm³' },
        { name: 'Cubic meter', symbol: 'm³' },
        { name: 'Litre', symbol: 'L' },

        { name: 'Gram', symbol: 'g' },
        { name: 'Kilogram', symbol: 'kg' },
        { name: 'Tonne', symbol: 't' },

        { name: 'Picovolt', symbol: 'pV' },
        { name: 'Nanovolt', symbol: 'nV' },
        { name: 'Microvolt', symbol: 'µV' },
        { name: 'Millivolt', symbol: 'mV' },
        { name: 'Volt', symbol: 'V' },
        { name: 'Kilovolt', symbol: 'kV' },

        { name: 'Picoampere', symbol: 'pA' },
        { name: 'Nanoampere', symbol: 'nA' },
        { name: 'Microampere', symbol: 'µA' },
        { name: 'Milliampere', symbol: 'mA' },
        { name: 'Ampere', symbol: 'A' },
        { name: 'Kiloampere', symbol: 'kA' },

        { name: 'Picofarad', symbol: 'pF' },
        { name: 'Nanofarad', symbol: 'nF' },
        { name: 'Microfarad', symbol: 'µF' },
        { name: 'Millifarad', symbol: 'mF' },
        { name: 'Farad', symbol: 'F' },

        { name: 'Ohm', symbol: 'Ω' },
        { name: 'Kiloohm', symbol: 'kΩ' },
        { name: 'Megaohm', symbol: 'MΩ' },

        { name: 'Watt', symbol: 'W' },
        { name: 'Kilowatt', symbol: 'kW' },
        { name: 'Megawatt', symbol: 'MW' },

        { name: 'Hertz', symbol: 'Hz' },
        { name: 'Kilohertz', symbol: 'kHz' },
        { name: 'Megahertz', symbol: 'MHz' },
        { name: 'Gigahertz', symbol: 'GHz' },

        { name: 'Joule', symbol: 'J' },
        { name: 'Newton', symbol: 'N' },
        { name: 'Pascal', symbol: 'Pa' },

        { name: 'Second', symbol: 's' },
        { name: 'Minute', symbol: 'min' },
        { name: 'Hour', symbol: 'h' },

        { name: 'Degree Celsius', symbol: '°C' },
        { name: 'Kelvin', symbol: 'K' },
        { name: 'Degree Fahrenheit', symbol: '°F' },

        { name: 'Percent', symbol: '%'},
        { name: 'Unitless', symbol: '-' }
    ];
    const seriesColors = ['#0000FF', '#4CAF50', '#9B1E1E', '#FF9800', '#9C27B0', '#00BCD4', '#E91E63', '#8BC34A', '#3F51B5', '#FFC107', '#795548', '#607D8B'];
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices?page=1&&limit=1000`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when retrieving devices summary: ',error);
        }
    };
    const fetchSelectedDataSourceDevice = async() =>{
        try{
            if(!selectedDataSourceDeviceSummary || !selectedDataSourceDeviceSummary.id) return;
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices/${selectedDataSourceDeviceSummary?.id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setSelectedDataSourceDevice(responseData);
            }
        }
        catch(error){
            console.error('An error occurred when retrieving the selected device: ',error);
        }
    };
    const isFormComplete = () =>{
        return selectedDataSourceDevice !== null && series && series.length > 0 && series.every(seriesEntry =>
            seriesEntry?.key && seriesEntry?.units
        );
    };
    const getIncompleteFormString = () =>{
        return selectedDataSourceDevice === null? 'Please select the data source device':
            series.length === 0? 'At least one series is required':isFormComplete()? '':'One or more of the series has incomplete fields'
    };
    const hexToRgb = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgb(${r}, ${g}, ${b})`;
    };
    const getBrightness = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (0.2126 * r + 0.7152 * g + 0.0722 * b);
    };
    const loadActiveEditWidget = () =>{
        setTimeWindowSource(activeEditWidget?.config?.timeWindowSource);
        setDisplayTimeWindow(activeEditWidget?.config?.displayTimeWindow);
        setTimeWindow(activeEditWidget?.config?.timeWindow);
        setSelectedDataSourceType('device');
        setSelectedDataSourceDeviceId(activeEditWidget?.config?.dataSource?.deviceId);
        setTitle(activeEditWidget?.config?.appearance?.title);
        setShowTitle(activeEditWidget?.config?.appearance?.showTitle);
        setTitleColor(activeEditWidget?.config?.appearance?.titleColor);
        setBorderRadius(activeEditWidget?.borderRadius);
        setMobileHeightFactor(activeEditWidget?.mobileHeightFactor);
        setMaximumValue(isNaN(activeEditWidget?.config?.appearance?.maximumValue)? '':Number(activeEditWidget?.config?.appearance?.maximumValue).toLocaleString('en-US'));
    };
    const timeWindowHasChanges = () =>{
        const filteredTimeWindow = {
            displayValue: timeWindow?.displayValue,
            hideAggregation: timeWindow?.hideAggregation,
            hideAggInterval: timeWindow?.hideAggInterval,
            hideTimeZone: timeWindow?.hideTimeZone,
            selectedTab: timeWindow?.selectedTab,
            realTime: {
                realTimeType: timeWindow?.realTime?.realTimeType,
                interval: timeWindow?.realTime?.interval,
                timeWindowMs: timeWindow?.realTime?.timeWindowMs,
                quickInterval: timeWindow?.realTime?.quickInterval,
                hideInterval: timeWindow?.realTime?.hideInterval,
                hideLastInterval: timeWindow?.realTime?.hideLastInterval,
                hideQuickInterval: timeWindow?.realTime?.hideQuickInterval
            },
            history: {
                historyType: timeWindow?.history?.historyType,
                interval: timeWindow?.history?.interval,
                timeWindowMs: timeWindow?.history?.timeWindowMs,
                quickInterval: timeWindow?.history?.quickInterval,
                hideInterval: timeWindow?.history?.hideInterval,
                hideLastInterval: timeWindow?.history?.hideLastInterval,
                hideFixedInterval: timeWindow?.history?.hideFixedInterval,
                hideQuickInterval: timeWindow?.history?.hideQuickInterval,
                fixedTimeWindow: {
                    startTimeMs: timeWindow?.history?.fixedTimeWindow?.startTimeMs,
                    endTimeMs: timeWindow?.history?.fixedTimeWindow?.endTimeMs
                }
            },
            aggregation: {
                type: timeWindow?.aggregation?.type,
                limit: timeWindow?.aggregation?.limit
            }
        };
        return JSON.stringify(filteredTimeWindow) !== JSON.stringify(activeEditWidget?.config?.timeWindow);
    }
    const checkChanges = () =>{
        const filteredSeries = series?.map(({key,label,color,units,decimals}) =>({
            key,label,color,units,decimals
        }));
        if(
            timeWindowSource !== activeEditWidget?.config?.timeWindowSource ||
            displayTimeWindow !== activeEditWidget?.config?.displayTimeWindow ||
            timeWindowHasChanges() ||
            selectedDataSourceDeviceSummary?.id !== activeEditWidget?.config?.dataSource?.deviceId ||
            JSON.stringify(filteredSeries) !== JSON.stringify(activeEditWidget?.config?.series) ||
            title !== activeEditWidget?.config?.appearance?.title||
            showTitle !== activeEditWidget?.config?.appearance?.showTitle||
            titleColor?.toUpperCase() !== activeEditWidget?.config?.appearance?.titleColor ||
            borderRadius !== activeEditWidget?.borderRadius ||
            mobileHeightFactor !== activeEditWidget?.mobileHeightFactor ||
            (!isNaN(Number(maximumValue))? String(maximumValue).replaceAll(',',''):'') !== String(activeEditWidget?.config?.appearance?.maximumValue).replaceAll(',','')
        ) setChangesAvailable(true);
        else setChangesAvailable(false);
    };
    const setUpdatedWidget = () =>{
        const updatedBarChart = activeEditWidget;
        updatedBarChart.config = {
            timeWindow:timeWindow,
            timeWindowSource:timeWindowSource,
            displayTimeWindow:displayTimeWindow,
            dataSource:{
                deviceId: selectedDataSourceDevice?.id
            },
            series: series.map((seriesEntry) =>({
                key: seriesEntry?.key,
                label: seriesEntry?.label,
                color:seriesEntry?.color,
                units:seriesEntry?.units,
                decimals:seriesEntry?.decimals
            })),
            appearance:{
                title: title,
                showTitle: showTitle,
                titleColor: titleColor,
                maximumValue:!maximumValue || isNaN(Number(String(maximumValue).replaceAll(',','')))? 0:Number(String(maximumValue).replaceAll(',',''))
            }
        };
        updatedBarChart.borderRadius = borderRadius;
        updatedBarChart.mobileHeightFactor = mobileHeightFactor;
        return updatedBarChart;
    };
    const resetEntries = () =>{
        setTimeWindowSource('WIDGET');
        setDisplayTimeWindow(true);
        setShowTimeWindowSelector(false);
        setTimeWindow({...defaultTimeWindow});
        setSelectedDataSourceType('device');
        setShowDevicesBrowser(false);
        setShowEntityAliasBrowser(false);
        setDevicesSummary([]);
        setDataSourceDeviceFilterString('');
        setDataSourceEntityAliasFilterString('');
        setSelectedDataSourceDeviceSummary(null);
        setSelectedDataSourceDevice(null);
        setSelectedDataSourceDeviceId('');
        setSeries([]);
        setTitle('');
        setShowTitle(true);
        setTitleColor('#000000');
        setBorderRadius(0);
        setMobileHeightFactor(5);
        setMaximumValue('');
    };
    const disposeWindow = () =>{
        resetEntries();
        setActiveEditWidget(null);
    };
    const updateWidget = () =>{
        setUpdatedWidget();
        disposeWindow();
    };
    useEffect(() =>{
        if(activeEditWidget && activeEditWidget?.type === 'bar_chart'){
            loadActiveEditWidget();
            fetchDevicesSummary();
        }
    },[activeEditWidget]);
    useEffect(() =>{
        const clickOutsideTimeWindowSelectorContainer = (e) =>{
            if(showTimeWindowSelector && timeWindowSelectorContainerRef.current && !timeWindowSelectorContainerRef.current.contains(e.target)){
                setShowTimeWindowSelector(false);
            }
        };
        document.addEventListener("mousedown",clickOutsideTimeWindowSelectorContainer);
        return () =>{
            document.removeEventListener("mousedown",clickOutsideTimeWindowSelectorContainer);
        }
    },[showTimeWindowSelector]);
    useEffect(() => {
        setDataSourceDeviceFilterString('');
        setDataSourceEntityAliasFilterString('');
        setSelectedDataSourceDeviceSummary(null);
    },[selectedDataSourceType]);
    useEffect(() =>{
        if(devicesSummary && devicesSummary.length > 0 && selectedDataSourceDeviceId !== null && selectedDataSourceDeviceId !== ''){
            devicesSummary.forEach(deviceSummary => {
                if(deviceSummary?.id === selectedDataSourceDeviceId){
                    setSelectedDataSourceDeviceSummary(deviceSummary);
                }
            })
        }
    },[devicesSummary,selectedDataSourceDeviceId]);
    useEffect(() =>{
        if(selectedDataSourceDeviceSummary){
            fetchSelectedDataSourceDevice();
        }
        else setSelectedDataSourceDevice(null);
    },[selectedDataSourceDeviceSummary]);
    useEffect(() =>{
        if(selectedDataSourceDeviceId !== null && selectedDataSourceDeviceId !== ''){
            setSelectedDataSourceDeviceId(null);
            setSeries(activeEditWidget?.config?.series.map(seriesEntry =>({
                ...seriesEntry,
                id: uuidv4(),
                seriesKeyFilterString: '',
                showSeriesKeysBrowser: false,
                keys: selectedDataSourceDevice?.latestTelemetry?.map(t => t?.key) || [],
                unitsFilterString: '',
                showSeriesKeysBrowser: false
            })));
        }
        if(selectedDataSourceDevice) setTitle(selectedDataSourceDevice?.name);
        else{
            setSeries([]);
            setTitle('');
        }
    },[selectedDataSourceDevice]);
    useEffect(() =>{
        checkChanges();
    },[
        timeWindowSource,displayTimeWindow,timeWindow,selectedDataSourceDeviceSummary,
        series,title,showTitle,titleColor,borderRadius,mobileHeightFactor,maximumValue]);
    return (
        <div className="edit-bar-chart-widget-container">
            <div className="edit-bar-chart-widget-header-container">
                <div className="edit-bar-chart-widget-main-header-container">
                    <div>
                        <h2>{title}</h2>
                        <p>Bar chart</p>
                    </div>
                    <div>
                        <button
                            className="help-button"
                            title="Go to help page">?</button>
                        <button
                            className="close-editor-button"
                            onClick={() => disposeWindow()}
                            title="Close the editor">&#10006;</button>
                    </div>
                </div>
                <div className="edit-bar-chart-widget-minor-header-container">
                    <div>
                        <button
                            className={changesAvailable? 'decline active':'decline inactive'}
                            onClick={() =>disposeWindow()}>&#10006; Decline
                        </button>
                        <button
                            className={changesAvailable && getIncompleteFormString().length === 0? 'apply active':'apply inactive'}
                            title={getIncompleteFormString()}
                            disabled={!changesAvailable || getIncompleteFormString().length > 0}
                            onClick={() => updateWidget()}>&#10003; Apply
                        </button>
                    </div>
                </div>
            </div>
            <div className="edit-bar-chart-widget-body-container">
                <div className="edit-bar-chart-widget-time-window-container">
                    <div className="header">
                        <h2>Time window</h2>
                        <div>
                            <button className={timeWindowSource === 'DASHBOARD'? ' active':''} onClick={() => setTimeWindowSource('DASHBOARD')}>
                                Use dashboard time window
                            </button>
                            <button className={timeWindowSource === 'WIDGET'? ' active':''} onClick={() => setTimeWindowSource('WIDGET')}>
                                Use widget time window
                            </button>
                        </div>
                    </div>
                    <div className="body">
                        <ToogleButton
                            size="45px"
                            marginTop="4px"
                            isToogled={displayTimeWindow}
                            onChange={() => setDisplayTimeWindow(!displayTimeWindow)}
                        />
                        <p>Display time window</p>
                        <div ref={timeWindowSelectorContainerRef} className="time-window-selector-container">
                            <button
                                className="show-time-window-selector-button"
                                onClick={() => setShowTimeWindowSelector(!showTimeWindowSelector)}>
                                <img src={`${process.env.PUBLIC_URL}/images/clock-icon.png`}/>
                                {timeWindow?.selectedTab === 0? 'Real time':'History'} - {
                                    timeWindow?.selectedTab === 0?
                                    timeWindow?.realTime?.realTimeType === 0? `last ${getTimeIntervalByValue(timeWindow?.realTime?.timeWindowMs).replace(/^1 /, '')}`:getQuickIntervalByValue(timeWindow?.realTime?.quickInterval):
                                    timeWindow?.history?.historyType === 0? `last ${getTimeIntervalByValue(timeWindow?.history?.timeWindowMs).replace(/^1 /, '')}`:
                                    timeWindow?.history?.historyType === 1? `from ${(new Date(timeWindow?.history?.fixedTimeWindow?.startTimeMs))?.toLocaleString()} to ${(new Date(timeWindow?.history?.fixedTimeWindow?.endTimeMs))?.toLocaleString()}`
                                    :getQuickIntervalByValue(timeWindow?.history?.quickInterval)
                                }
                            </button>
                            <TimeWindowSelector
                                showTimeWindowSelector={showTimeWindowSelector}
                                setShowTimeWindowSelector={setShowTimeWindowSelector}
                                timeWindow={timeWindow}
                                setTimeWindow={setTimeWindow}
                            />
                        </div>
                        <div className={`inactive-time-window-mask ${timeWindowSource !== 'WIDGET'? 'active':''}`}></div>
                    </div>
                </div>
                <div className="edit-bar-chart-widget-data-source-container">
                    <div className="header">
                        <h2>Datasource</h2>
                        <div>
                            <button className={selectedDataSourceType === 'device'? ' active':''}
                                onClick={() => setSelectedDataSourceType('device')}>
                                Device
                            </button>
                            <button className={selectedDataSourceType === 'entity'? ' active':''}
                                onClick={() => setSelectedDataSourceType('entity')}>
                                Entity alias
                            </button>
                        </div>
                    </div>
                    {selectedDataSourceType === 'device'? (
                        <div className="body">
                            <div className="device-selection-container">
                                <p>Device<span>*</span></p>
                                <div className="entry-container">
                                    <input className={`${selectedDataSourceDevice? 'active':'inactive'}`}
                                        placeholder="Select a device"
                                        value={
                                            selectedDataSourceDevice? selectedDataSourceDevice?.name:dataSourceDeviceFilterString}
                                        onChange={(e) => setDataSourceDeviceFilterString(e.target.value)}
                                        onFocus={() => setShowDevicesBrowser(true)}
                                        onBlur={() => {
                                            setTimeout(() =>{
                                                setShowDevicesBrowser(false)
                                            },250);
                                        }}
                                    />
                                    <p  style={{display:selectedDataSourceDeviceSummary? 'flex':'none'}}
                                        title="Remove selected device"
                                        onClick={() =>{
                                            setDataSourceDeviceFilterString('');
                                            setSelectedDataSourceDeviceSummary(null);
                                        }}>&#10006;
                                    </p>
                                </div>
                                <div className={`devices-browser ${showDevicesBrowser? 'active':''}`}>
                                    {(devicesSummary && devicesSummary.length > 0 &&
                                    [...devicesSummary].filter(deviceSummary => deviceSummary?.name?.toLowerCase().includes(dataSourceDeviceFilterString?.toLowerCase()))
                                    .sort((a,b) => a.name.localeCompare(b.name)).map((deviceSummary) => (
                                        <div key={deviceSummary?.id} onClick={(e) =>{
                                            e.stopPropagation();
                                            setSelectedDataSourceDeviceSummary(deviceSummary);
                                        }}>
                                            {deviceSummary?.name}
                                        </div>
                                    )))}
                                </div>
                            </div>
                            <p className="label" style={{display:(selectedDataSourceDevice || showDevicesBrowser)? 'none':'block'}}>Device is required</p>
                        </div>
                    ):(
                        <div className="body">
                            <div className="entity-alias-selection-container">
                                <p>Entity alias<span>*</span></p>
                                <div className="entry-container">
                                    <input className={`inactive`}
                                        placeholder="Select an entity alias"
                                        value={dataSourceEntityAliasFilterString}
                                        onChange={(e) => setDataSourceEntityAliasFilterString(e.target.value)}
                                        onFocus={() => setShowEntityAliasBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowEntityAliasBrowser(false)},200)}
                                    />
                                </div>
                                <div className={`entity-alias-browser ${showEntityAliasBrowser? 'active':''}`}>
                                    <div>
                                        No aliases found!
                                    </div>
                                </div>
                            </div>
                            <p className="label">Entity alias is required</p>
                        </div>
                    )}
                </div>
                <div className="edit-bar-chart-widget-series-container">
                    <h2>Series</h2>
                    {selectedDataSourceDevice?(
                        <div className="body">
                            <table>
                                <thead>
                                    <tr className="header-row">
                                        <th style={{width:'26%'}}>Key</th>
                                        <th style={{width:'24%'}}>Label</th>
                                        <th style={{width:'9%'}}>Color</th>
                                        <th style={{width:'20%'}}>Units</th>
                                        <th style={{width:'12%'}}>Decimals</th>
                                        <th style={{width:'9%'}}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {series && series.length> 0? series.map(seriesEntry => (
                                        <tr key={seriesEntry?.id}>
                                            <td className="series-key-container">
                                                <input
                                                    style={{display:seriesEntry?.key? 'none':'block'}}
                                                    placeholder="Set"
                                                    value={seriesEntry?.seriesKeyFilterString}
                                                    onChange={(e) => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,seriesKeyFilterString:e.target.value}:entry))}
                                                    onFocus={() => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,showSeriesKeysBrowser:true}:entry))}
                                                    onBlur={() => setTimeout(() =>{
                                                        setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,showSeriesKeysBrowser:false}:entry))
                                                    },250)}
                                                />
                                                <div className="series-key-entry"
                                                    style={{display:seriesEntry?.key? 'block':'none'}}>
                                                    <div>
                                                        <div className="key-icon-container">
                                                            <span className="key-icon">↯</span>
                                                        </div>
                                                        <div className="key-entry-container">
                                                            <span className="key-entry">{seriesEntry?.key}</span>
                                                        </div>
                                                        <span className="remove-key" title="Remove key" onClick={() =>{
                                                            setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry, key:null}:entry));
                                                        }}>&#10005;</span>
                                                    </div>
                                                </div>
                                                <div className={`series-keys-browser ${(seriesEntry?.key?.length > 0 || !seriesEntry?.showSeriesKeysBrowser)? '':'active'}`}>
                                                    {seriesEntry?.keys?.length > 0
                                                    && [...seriesEntry.keys].filter(seriesEntryKey => seriesEntryKey.toLowerCase().includes(seriesEntry?.seriesKeyFilterString?.toLowerCase()))
                                                    .sort((a,b) => (a.localeCompare(b)))
                                                    .map((seriesEntryKey,index) =>(
                                                        <div key={index} onClick={() => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {
                                                                ...entry,
                                                                key:seriesEntryKey,
                                                                seriesKeyFilterString:'',
                                                                label:(!seriesEntry?.label || seriesEntry?.label === ''? seriesEntryKey:seriesEntry?.label)
                                                            }:entry))}>
                                                            <span>↯</span>{seriesEntryKey}
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                            <td className="series-label-container">
                                                <input
                                                    placeholder="Set"
                                                    value={seriesEntry?.label}
                                                    onChange={(e) => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,label:e.target.value}:entry))}
                                                />
                                            </td>
                                            <td className="series-color-container">
                                                <input
                                                    type="color"
                                                    value={seriesEntry?.color}
                                                    onChange={(e) => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,color:e.target.value}:entry))}
                                                />
                                            </td>
                                            <td className="series-units-container">
                                                <input
                                                    style={{display:seriesEntry?.units? 'none':'block'}}
                                                    placeholder="Set"
                                                    value={seriesEntry?.unitsFilterString}
                                                    onChange={(e) => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,unitsFilterString:e.target.value}:entry))}
                                                    onFocus={() => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,showSeriesUnitsBrowser:true}:entry))}
                                                    onBlur={() => setTimeout(() => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,showSeriesUnitsBrowser:false}:entry)),200)}
                                                />
                                                <div className="units-key-entry"
                                                    style={{display:seriesEntry?.units? 'flex':'none'}}>
                                                        <span>{seriesEntry?.units?.symbol}</span>
                                                        <span
                                                            className="remove-units"
                                                            title="Remove unit"
                                                            onClick={() => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,units:null}:entry))}>&#10005;</span>
                                                </div>
                                                <div className={`series-units-browser ${(seriesEntry?.units || !seriesEntry?.showSeriesUnitsBrowser)? '':'active'}`}>
                                                    {units.filter(unitEntry => (unitEntry?.name?.toLowerCase().includes(seriesEntry?.unitsFilterString?.toLowerCase()) || 
                                                    unitEntry?.symbol?.toLowerCase().includes(seriesEntry?.unitsFilterString?.toLowerCase()))).map((unit,index) =>(
                                                        <div key={index} onClick={() =>{
                                                            setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,units:unit}:entry))
                                                            setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,unitsFilterString:''}:entry))
                                                        }}>
                                                            <span>{unit?.name}</span> <span>{unit?.symbol}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                            <td className="series-decimals-container">
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={15}
                                                    value={seriesEntry?.decimals}
                                                    onKeyDown={(e) =>{
                                                        if(["e","E","+","-","."].includes(e.key)) e.preventDefault();
                                                    }}
                                                    onChange={(e) => setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,decimals:e.target.value}:entry))}
                                                    onBlur={() =>{
                                                        if(seriesEntry?.decimals === ''||isNaN(Number(seriesEntry?.decimals))) setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,decimals:0}:entry));
                                                        else if(Number(seriesEntry?.decimals) > 15) setSeries(prev => prev.map(entry => entry?.id === seriesEntry?.id? {...entry,decimals:15}:entry)); 
                                                    }}
                                                />
                                            </td>
                                            <td className="series-delete-container">
                                                <button title="Remove series"
                                                    onClick={() => setSeries(prev => prev.filter(entry => entry?.id !== seriesEntry?.id))}>
                                                    <img src={`${process.env.PUBLIC_URL}/images/gray-bin-icon.png`}/>
                                                </button>
                                            </td>
                                        </tr>
                                    )):
                                    <tr className="empty-series-container">
                                        <td colSpan={7}>
                                            <h3>No series configured</h3>
                                            <p>At least one series should be specified</p>
                                        </td>
                                    </tr>}
                                </tbody>
                            </table>
                            <button className="add-series-button"
                                onClick={() =>{
                                    let newSeriesEntryId;
                                    do{
                                        newSeriesEntryId = uuidv4();
                                    }while(series.some(entry => entry.id === newSeriesEntryId));
                                    setSeries(prev =>[...prev,{
                                        id:newSeriesEntryId,
                                        seriesKeyFilterString:'',
                                        showSeriesKeysBrowser:false,
                                        key:null,
                                        keys:selectedDataSourceDevice?.latestTelemetry? (selectedDataSourceDevice?.latestTelemetry?.map(latestTelemetryEntry =>(
                                            latestTelemetryEntry?.key
                                        ))):[],
                                        label:'',
                                        color:seriesColors[series.length % seriesColors?.length],
                                        unitsFilterString:'',
                                        showSeriesUnitsBrowser:false,
                                        units:null,
                                        decimals:0
                                    }]);
                                }}
                                >Add series
                            </button>
                        </div>
                    ):(
                        <div className="empty-data-source-container">
                            <h3>No data source selected</h3>
                            <p>Please select a data source to configure a series.</p>
                        </div>
                    )}
                </div>
                <div className="edit-bar-chart-widget-appearance-container">
                    <h2>Appearance</h2>
                    <div className="body">
                        <div className="title-container">
                            <div className="title-entry-container">
                                <p>Title</p>
                                <input
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className="show-title-container">
                                <p>Show title</p>
                                <ToogleButton
                                    size="50px"
                                    marginTop="4px"
                                    marginLeft="20px"
                                    isToogled={showTitle}
                                    onChange={() => setShowTitle(!showTitle)}
                                />
                            </div>
                        </div>
                        <div className="title-color-container">
                            <p>Title color</p>
                            <div>
                                <p style={{
                                    color:titleColor,
                                    textShadow: getBrightness(titleColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                }}>{hexToRgb(titleColor)}</p>
                                <input
                                    type="color"
                                    title="Select color"
                                    value={titleColor}
                                    onChange={(e) => setTitleColor(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="border-radius-container">
                            <p>Border radius</p>
                            <div>
                                <p>{borderRadius}%</p>
                                <input
                                    type="range"
                                    min={0}
                                    max={100}
                                    step={1}
                                    value={borderRadius}
                                    onChange={(e) => setBorderRadius(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="mobile-height-container">
                            <p>Mobile height factor</p>
                            <div>
                                <p>{mobileHeightFactor}</p>
                                <input
                                    type="range"
                                    min={1}
                                    max={10}
                                    step={0.1}
                                    value={mobileHeightFactor}
                                    onChange={(e) => setMobileHeightFactor(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="maximum-value-container">
                            <p>Maximum value</p>
                            <input
                                placeholder="Enter the maximum value the chart should scale to"
                                value={maximumValue}
                                onChange={(e) =>{
                                    const value = e.target.value.replaceAll(',','');
                                    if(/^\d*$/.test(value)) setMaximumValue(value);
                                }}
                                onFocus={(e) =>{
                                    setMaximumValue(maximumValue? String(maximumValue).replaceAll(',',''):'');
                                }}
                                onBlur={(e) =>{
                                    if(maximumValue === '') return;
                                    else if(!isNaN(Number(maximumValue))) setMaximumValue(Number(maximumValue).toLocaleString('en-US'));
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EditBarChartWidget;